// -----------------------------------------------------------------------------
// Suoni brevi del countdown (Fase UX) — Web Audio API, nessuna libreria esterna,
// nessuna voce. Tick discreto per i numeri, suono più evidente per "VIA!".
// Va sbloccato con un gesto utente su iOS (primeSound nel tap "NUOVA PARTITA").
// Fallback silenzioso se l'API non è disponibile.
// -----------------------------------------------------------------------------
let ctx = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  try {
    if (!ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      ctx = new AC();
    }
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

// Da chiamare dentro un gesto utente per sbloccare l'audio su Safari/iOS.
export function primeSound() {
  getCtx();
}

function beep(freq, durationMs, gainVal, type = "sine") {
  const c = getCtx();
  if (!c) return;
  try {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = type;
    o.frequency.value = freq;
    const now = c.currentTime;
    g.gain.setValueAtTime(gainVal, now);
    g.gain.exponentialRampToValueAtTime(0.0001, now + durationMs / 1000);
    o.connect(g);
    g.connect(c.destination);
    o.start(now);
    o.stop(now + durationMs / 1000 + 0.02);
  } catch {
    // fallback silenzioso
  }
}

export function playTick() {
  beep(660, 90, 0.15); // 5,4,3,2,1 — breve e discreto
}

export function playGo() {
  beep(990, 260, 0.25); // VIA! — più evidente
}

// Click brevissimo e discreto a ogni tap registrato. Volume basso e durata minima
// per non affaticare quando i tocchi sono molti e ravvicinati.
export function playTap() {
  beep(600, 32, 0.05, "triangle");
}

// Esito positivo: due note ascendenti brevi (si affianca al lampo verde).
export function playCorrect() {
  beep(784, 90, 0.11);
  setTimeout(() => beep(1175, 130, 0.11), 95);
}

// Esito negativo: due note discendenti brevi e morbide (si affianca al lampo rosso).
export function playWrong() {
  beep(233, 110, 0.11, "square");
  setTimeout(() => beep(155, 200, 0.1, "square"), 90);
}

// Milestone streak: breve arpeggio ascendente dedicato, di "grandezza" crescente col
// tier (5→1 nota-coppia, 10→terzina, 20/30/50→quartina). Sempre breve (<400ms) per
// non interferire col turno successivo. Distinto dal suono di risposta corretta.
export function playMilestone(tier) {
  const notes = tier >= 3 ? [784, 988, 1318, 1568] : tier === 2 ? [880, 1174, 1568] : [880, 1174];
  notes.forEach((f, i) => setTimeout(() => beep(f, 130, 0.1), i * 70));
}
